//https://disciple.sentry.io/issues/4927734798/?project=6718259&query=is%3Aunresolved&referrer=issue-stream&statsPeriod=30d&stream_index=1&utc=true
import "core-js/features/array/at"

import PortalVue from "portal-vue"
import Cookies from "js-cookie"

import App from "@/App.vue"

import vuetify from "@/plugins/vuetify"
import i18n, { i18nSetup } from "@/plugins/i18n.js"
import RouterState from "@/plugins/routerState.js"
import { eventBus } from "@/plugins/eventBus.js"
import Routes from "@/plugins/routes.js"
import Logger from "@/plugins/logger.js"
import TranslateHelper from "@/plugins/translate.js"
import pinia from "@/plugins/pinia.js"

import router from "@/router.js"
import apiUtils from "@/api/apiUtils.js"

import * as environment from "@/services/environment"
import * as texts from "@/services/texts"
import * as sentryReporter from "@/services/sentryReporter.js"

import "material-design-icons-iconfont/dist/material-design-icons.css"
import "swiper/scss"
import "cropperjs/dist/cropper.css"

import DynamicLink from "@/components/DynamicLink.vue"
import MessageDialog from "@/components/MessageDialog.vue"
import TheButton from "@/components/TheButton.vue"
import AppSelect from "@/components/AppSelect.vue"
import TextField from "@/components/TextField.vue"
import TextArea from "@/components/TextArea.vue"
import LoadingIndicator from "@/components/LoadingIndicator.vue"
import ActivatedPortal from "@/components/ActivatedPortal.vue"
import TheBottomNav from "@/components/navs/TheBottomNav.vue"
import HeaderMobile from "@/components/navs/HeaderMobile.vue"
import FillArea from "@/components/FillArea.vue"
import AppLogo from "@/components/navs/AppLogo.vue"
import OnboardingPageContent from "@/components/onboarding/OnboardingPageContent.vue"
import UserAvatar from "@/components/users/UserAvatar.vue"
import UserProfileLink from "@/components/users/UserProfileLink.vue"
import AppRuntimeTemplate from "@/components/AppRuntimeTemplate.vue"

import InlineSvg from "vue-inline-svg"

import { createApp } from "vue"

import { useConfigurationStore } from "@/store/configuration.js"
import { useAppStateStore } from "@/store/appState.js"
import { useUserSessionStore } from "@/store/userSession.js"

//Creating app here so sentry is initialized with it
const app = createApp(App)

app.use(pinia)

sentryReporter.setup({ app, router })
apiUtils.setup()
environment.setInstallPrompt()
;(async () => {
  try {
    const configurationStore = useConfigurationStore()
    const appStateStore = useAppStateStore()
    const userSessionStore = useUserSessionStore()

    await texts.setupSplitter()
    //UserSession uses configuration, need to fetch configuration first
    await configurationStore.fetchConfiguration({ includeRegistrationSnippets: true })
    //Set session for web view if needed
    const webViewSecret = Cookies.get("X-Secret")
    const webViewSecretId = Cookies.get("X-Secret-Id")

    if (webViewSecret && webViewSecretId) {
      appStateStore.setWebViewMode()
      userSessionStore.setSessionData({
        secret: webViewSecret,
        secret_id: webViewSecretId
      })
      Cookies.remove("X-Secret")
      Cookies.remove("X-Secret-Id")
    }
    await userSessionStore.setUserData()
  } catch (err) {
    sentryReporter.reportError(err)
  } finally {
    await Promise.allSettled([environment.setup(), i18nSetup()])

    app.use(vuetify)
    app.use(i18n)
    app.use(router)
    app.use(Logger)
    app.use(RouterState)
    app.use(Routes)
    app.use(eventBus)
    app.use(PortalVue)
    app.use(TranslateHelper)

    app.component("TheButton", TheButton)
    app.component("AppSelect", AppSelect)
    app.component("MessageDialog", MessageDialog)
    app.component("LoadingIndicator", LoadingIndicator)
    app.component("DynamicLink", DynamicLink)
    app.component("TextField", TextField)
    app.component("TextArea", TextArea)
    app.component("ActivatedPortal", ActivatedPortal)
    app.component("InlineSvg", InlineSvg)
    app.component("TheBottomNav", TheBottomNav)
    app.component("HeaderMobile", HeaderMobile)
    app.component("FillArea", FillArea)
    app.component("AppLogo", AppLogo)
    app.component("OnboardingPageContent", OnboardingPageContent)
    app.component("UserAvatar", UserAvatar)
    app.component("UserProfileLink", UserProfileLink)
    app.component("AppRuntimeTemplate", AppRuntimeTemplate)

    app.mount("#app")

    if (import.meta.env.VITE_APP_E2E) {
      //Remove element with id="embed"
      document.getElementById("embed").remove()
    }
  }
})()
